var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"compareHorizontal"}},[_c('l-map',{ref:"compareHorizontalMap",staticStyle:{"z-index":"0","background-color":"black"},attrs:{"options":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }